module.exports = __webpack_public_path__ + "static/media/icon_141.a23029f0.svg";